export const menuData = [
    {title: 'About', link: '/about'},
    {title: 'Projects', link: '/projects'},
    {title: 'Packages', link: '/packages'}
];